import Vue from 'vue'
import router from './router'
import store from './store'
import helpers from "@/plugins/helpers";
import auth from "@/plugins/auth";
import WebRouter from "@/components/WebRouter";
import Bugsnag from "@bugsnag/js";
import {isDev} from "@/helpers";

const {VUE_APP_BUGSNAG_KEY} = process.env;

if (!isDev()) {
  Bugsnag.start(VUE_APP_BUGSNAG_KEY)
}

require('bootstrap/dist/css/bootstrap.css');
require('@/styles/web.scss');

Vue.config.productionTip = false

Vue.use(helpers);
Vue.use(auth);

new Vue({
  created() {
    this.$api.setContext(this);
  },
  router,
  store,
  render: h => h(WebRouter)
}).$mount('#app')
